// Provides the ApiClient to hooks so tests can inject a mock without touching
// module-level singletons. Defaults to the real `api` singleton in production.
import { createContext, useContext, type ReactNode } from 'react';
import { api as defaultApi, type ApiClient } from './api';

const ApiContext = createContext<ApiClient>(defaultApi);

export function ApiProvider({ client, children }: { client: ApiClient; children: ReactNode }) {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApiClient(): ApiClient {
  return useContext(ApiContext);
}
